import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { getLanguage, getQueryString } from 'utils/params';
import { getCategories } from '../aboutIsn.api';
import { BreadcrumbAboutIsn, AboutIsnContent } from '../common';

const AboutIsnComponent = () => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());
  const [data, setData] = useState([]);
  
  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    getCategories(getQueryString({language})).then(res => {
      if(res?.data){
        setData(res?.data);
      }
    })
  }, [language])

  const breadCrumb = [{ title: t('about_isn.home'), url: '/' }, { title: t('about_isn.about_us') }];

  return (
    <>
      <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
      <AboutIsnContent data={data} />
    </>
  );
};

export default AboutIsnComponent;
